import React from 'react';

import '../style.scss';

export const Shortcuts = () => {
  return (
    <div className="shortcuts-skeleton">
      {[1, 2, 3, 4].map((v) =>
        <div className="skeleton" key={v}>
          <div>
            <div className="paragraph skeleton-square"></div>
          </div>
        </div>,
      )}
    </div>
  );
};
